import React from 'react'
import { useDispatch } from 'react-redux'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import clsx from 'clsx'
import { setCancelImportDialog, useImportCSVData } from 'app/store/importCSV'
import { cancelImportThunk } from 'app/store/importCSV/importCSVExtraReducers'
import CancelButton from 'app/components/buttons/CancelButton'
import DeleteButton from 'app/components/buttons/DeleteButton'
import { cancelImportSISDataThunk } from 'app/store/importExternalSource/importExternalSourceReducers'
import { CANCEL_IMPORT_CSV } from '../../../constansts'
import useStyles from '../DialogDeleteCSVFile/styles'

const CancelImportDialog = () => {
  const dispatch = useDispatch()
  const { cancelProcessDialog } = useImportCSVData()

  const [isProcessing, setIsProcessing] = React.useState(false)

  const { formatMessage } = useIntl()

  const classes = useStyles()

  const isCancelImportCSVType = cancelProcessDialog === CANCEL_IMPORT_CSV

  const closeDialog = () => {
    dispatch(setCancelImportDialog(null))
  }

  const cancelImport = () => {
    if (isProcessing) return
    setIsProcessing(true)
    const errorMessage = formatMessage({ id: 'wrong.msg' })
    if (isCancelImportCSVType) {
      dispatch(cancelImportThunk({ errorMessage })).finally(() =>
        setIsProcessing(false),
      )
    } else {
      dispatch(cancelImportSISDataThunk({ errorMessage })).finally(() =>
        setIsProcessing(false),
      )
    }
  }

  const title = isCancelImportCSVType
    ? 'subscribers.import.cancelImportDialog.title'
    : 'subscribers.import.cancelSISImportDialog.title'
  const description = isCancelImportCSVType
    ? 'subscribers.import.cancelImportDialog.description'
    : 'subscribers.import.cancelSISImportDialog.description'

  const labelCancelBtn = isCancelImportCSVType
    ? 'subscribers.import.progressBar.text4'
    : 'subscribers.import.cancelSISImportDialog.cancelBtn.label'

  return (
    <Dialog className={clsx(classes.deleteDialog)} open={!!cancelProcessDialog}>
      <DialogTitle className={classes.deleteDialogTitle}>
        <FormattedMessage id={title} />
      </DialogTitle>
      <DialogContent className={classes.deleteDialogContent}>
        <FormattedMessage id={description} />
      </DialogContent>
      <DialogActions className={classes.deleteDialogActions}>
        <CancelButton
          labelId={'text.close'}
          onClick={closeDialog}
          variant="outlined"
          className={classes.cancelBtn}
        />
        <DeleteButton
          msgId={labelCancelBtn}
          onClick={cancelImport}
          disabled={isProcessing}
          isLoading={isProcessing}
        />
      </DialogActions>
    </Dialog>
  )
}

export default CancelImportDialog
